/* eslint-disable no-case-declarations */
import {
  SET_DASHBOARD_LIST, DASHBOARD_LIST_REQUEST_FAILED, SENDING_DASHBOARD_LIST_REQUEST,
} from '../../types/Types';

/** @type { Object } default state */
const defaultState = {
  dashboardListData: '',
  isDLSending: false,
  dLError: false,
  isDLSuccess: false,
};

/**
* dispatched the user data to the store
* @param  { Object } state  default state
* @param  { Object } action dispacthed action from middleware
*/
export default function getDashboardList(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_DASHBOARD_LIST:
      const data = {};
      data.dashboardListData = action.dashboardListData;
      data.isDLSending = action.isDLSending;
      data.isDLSuccess = action.isDLSuccess;
      data.dLError = action.dLError;
      return { ...state, ...data };

    case SENDING_DASHBOARD_LIST_REQUEST:
      const sendingRequest = {};
      sendingRequest.dashboardListData = action.dashboardListData;
      sendingRequest.isDLSending = action.isDLSending;
      sendingRequest.isDLSuccess = action.isDLSuccess;
      sendingRequest.dLError = action.dLError;
      return { ...state, ...sendingRequest };

    case DASHBOARD_LIST_REQUEST_FAILED:
      const errors = {};
      errors.dashboardListData = action.dashboardListData;
      errors.isDLSending = action.isDLSending;
      errors.isDLSuccess = action.isDLSuccess;
      errors.dLError = action.dLError;
      errors.fMsg = action.fMsg;
      return { ...state, ...errors };
    default: return state;
  }
}
